import { BusinessTypes } from '../../../constants/Enums';

export const quoteAndBookingInputState = (campaign) => {
    const state = { stepCompleted: false, stepEdited: false };

    // ToDo: add required checks
    if (campaign.businessType === BusinessTypes.AIRTIMEBURST.name) {
        if (
            campaign.campaignStatusName === 'Booked'
        ) {
            state.stepCompleted = true;
            state.stepEdited = true;
        }
    } else {
        const bookedOA = () => {
            let result = false;

            if (campaign.offairActivities && campaign.offairActivities.length > 0) {
                result = campaign.offairActivities.filter((of) => of.statusName === 'Booked' || of.statusName === 'Reserved');
            }

            return result.length > 0;
        };

        if (bookedOA()) {
            state.stepCompleted = true;
            state.stepEdited = true;
        }

        if (campaign?.businessType?.toLowerCase() === BusinessTypes.AIRTIME.name.toLowerCase()
            && (campaign?.bookedAirtimeQuote || campaign?.campaignStatusName === 'Cancelled')) {
            state.stepCompleted = true;
            state.stepEdited = true;
        }

        if (campaign?.businessType === BusinessTypes.SANDP.name && campaign?.bookedSAndPQuote) {
            state.stepCompleted = true;
            state.stepEdited = true;
        }
    }

    return state;
};
